import MapScreen from "@/screens/MapScreen"

export default MapScreen
